import React from "react";

type PricingPlanCardProps = {
  title: string;
  price: string;
  period?: string;
  features: string[];
  feeText: string;
  buttonText: string;
  featured?: boolean;
  badgeText?: string;
};

export const PricingPlanCard: React.FC<PricingPlanCardProps> = ({
  title,
  price,
  period,
  features,
  feeText,
  buttonText,
  featured = false,
  badgeText,
}) => {
  return (
    <div>
      <div className="hidden lg:block">
      <div
      className={`relative rounded-[34px] overflow-hidden shadow-lg ${
        featured
          ? "bg-[linear-gradient(135deg,#B90000_0%,#FF0000_55%,#FF1A1A_100%)] text-white"
          : "bg-[#FCFCFC] text-[#171717]"
      }`}
    >
      <div className="px-[44px] pt-[42px] pb-[36px] min-h-[715px] flex flex-col">
        {/* top area */}
        <div className="flex items-start justify-between gap-4">
          <div>
            <p
              className={`text-[18px] leading-none font-medium ${
                featured ? "text-white" : "text-[#171717]"
              }`}
            >
              {title}
            </p>

            <div className="mt-4 flex items-end gap-2">
              <span
                className={`text-[56px] leading-none font-semibold tracking-[-1.8px] ${
                  featured ? "text-white" : "text-[#171717]"
                }`}
              >
                {price}
              </span>

              {period ? (
                <span
                  className={`text-[20px] leading-none mb-[8px] ${
                    featured ? "text-white" : "text-[#171717]"
                  }`}
                >
                  /{period}
                </span>
              ) : null}
            </div>
          </div>

          {badgeText ? (
            <div className="mt-[20px] h-[42px] px-7 rounded-full bg-white text-[#E00000] text-[16px] font-medium flex items-center justify-center whitespace-nowrap">
              {badgeText}
            </div>
          ) : null}
        </div>

        {/* divider */}
        <div
          className={`my-10 border-1 border-solid border-t ${
            featured ? "border-white" : "border-[#E6E6E6]"
          }`}
        />

        {/* features */}
        <ul className=" space-y-8">
          {features.map((feature, index) => (
            <li key={index} className="flex items-center gap-4">
              <span
                className={`w-[22px] h-[22px] rounded-full flex items-center justify-center text-[12px] font-bold shrink-0 ${
                  featured
                    ? "bg-white text-[#E00000]"
                    : "bg-[#FF0000] text-white"
                }`}
              >
                ✓
              </span>

              <span
                className={`text-[20px] leading-[1.25] font-medium ${
                  featured ? "text-white" : "text-[#171717]"
                }`}
              >
                {feature}
              </span>
            </li>
          ))}
        </ul>

        {/* bottom */}
        <div className="mt-auto pt-14">
          <div
            className={`rounded-[22px] px-8 py-7 text-center text-[16px] leading-[1.35] ${
              featured
                ? "bg-white text-[#171717]"
                : "bg-[#F7EEEE] text-[#171717]"
            }`}
          >
            {feeText}
          </div>

          <div className="mt-8 flex justify-center">
            <a href="https://mycouponbook.ca/signup"
  className={`inline-flex items-center justify-center h-[52px] min-w-[200px] px-8 rounded-full text-[18px] font-medium transition ${
                featured
                  ? "bg-white text-[#E00000]"
                  : "bg-[linear-gradient(90deg,#FF0000_0%,#990000_100%)] text-white"
              }`}
            >
              {buttonText}
            </a>
          </div>
        </div>
      </div>
    </div>
      </div>


      <div className="block lg:hidden">
      <div
      className={`relative rounded-[34px] overflow-hidden shadow-lg ${
        featured
          ? "bg-[linear-gradient(135deg,#B90000_0%,#FF0000_55%,#FF1A1A_100%)] text-white"
          : "bg-[#FCFCFC] text-[#171717]"
      }`}
    >
      <div className="px-7 py-8  flex flex-col">
        {/* top area */}
        <div className="flex items-start justify-between gap-4">
          <div>
            <p
              className={`text-[14px] leading-none font-medium ${
                featured ? "text-white" : "text-[#171717]"
              }`}
            >
              {title}
            </p>

            <div className="mt-4 flex items-end gap-2">
              <span
                className={`text-[40px] leading-none font-semibold tracking-[-1.8px] ${
                  featured ? "text-white" : "text-[#171717]"
                }`}
              >
                {price}
              </span>

              {period ? (
                <span
                  className={`text-[12px] leading-none mb-[5px] ${
                    featured ? "text-white" : "text-[#171717]"
                  }`}
                >
                  /{period}
                </span>
              ) : null}
            </div>
          </div>

          {badgeText ? (
            <div className=" h-[42px] px-6 rounded-full bg-white text-[#E00000] text-[12px] font-medium flex items-center justify-center whitespace-nowrap">
              {badgeText}
            </div>
          ) : null}
        </div>

        {/* divider */}
        <div
          className={`my-10 border-1 border-solid border-t ${
            featured ? "border-white" : "border-[#E6E6E6]"
          }`}
        />

        {/* features */}
        <ul className="mt-2 space-y-8">
          {features.map((feature, index) => (
            <li key={index} className="flex items-center gap-4">
              <span
                className={`w-[22px] h-[22px] rounded-full flex items-center justify-center text-[12px] font-bold shrink-0 ${
                  featured
                    ? "bg-white text-[#E00000]"
                    : "bg-[#FF0000] text-white"
                }`}
              >
                ✓
              </span>

              <span
                className={`text-[16px] leading-[1.25] font-medium ${
                  featured ? "text-white" : "text-[#171717]"
                }`}
              >
                {feature}
              </span>
            </li>
          ))}
        </ul>

        {/* bottom */}
        <div className="pt-14">
          <div
            className={`rounded-[22px] px-4 py-7 text-center text-[12px] font-semibold leading-[1.35] ${
              featured
                ? "bg-white text-[#171717]"
                : "bg-[#F7EEEE] text-[#171717]"
            }`}
          >
            {feeText}
          </div>

          <div className="mt-8 flex justify-center">
          <a  href="https://mycouponbook.ca/signup"
            className={`inline-flex items-center justify-center h-[52px] min-w-[200px] px-8 rounded-full text-[18px] font-medium transition ${
              featured
                ? "bg-white text-[#E00000]"
                : "bg-[linear-gradient(90deg,#FF0000_0%,#990000_100%)] text-white"
            }`}
          >
            {buttonText}
          </a>
          </div>
        </div>
      </div>
    </div>
      </div>
    </div>
    
  );
};